import { render, staticRenderFns } from "./AdminFormsTable.vue?vue&type=template&id=51e3f84a&scoped=true"
import script from "./AdminFormsTable.vue?vue&type=script&lang=js"
export * from "./AdminFormsTable.vue?vue&type=script&lang=js"
import style0 from "./AdminFormsTable.vue?vue&type=style&index=0&id=51e3f84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e3f84a",
  null
  
)

export default component.exports